import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FaPencilAlt } from "react-icons/fa";
import Dropdown from 'react-bootstrap/Dropdown';
import axios from 'axios';

function ComTable({ caseId, currentComponents, onUpdate }) {
  const [show, setShow] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState('Select Option');
  const [componentValue, setComponentValue] = useState(currentComponents || '');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  // Update component value when currentComponents prop changes
  useEffect(() => {
    setComponentValue(currentComponents || '');
  }, [currentComponents]);

  const handleClose = () => {
    setShow(false);
    setShowSuccessAlert(false);
  };

  const handleShow = () => setShow(true);

  const handleSelect = (procedure) => {
    setSelectedProcedure(procedure);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}/components`,
        { components: componentValue }
      );

      if (response.status === 200 && response.data?.success) {
        setShowSuccessAlert(true);

        if (typeof onUpdate === 'function') {
          onUpdate(
            response.data.data?.components || componentValue
          );
        }

        setTimeout(() => {
          handleClose();
        }, 2000);
      } else {
        throw new Error(
          response.data?.message || 'Failed to update components'
        );
      }
    } catch (error) {
      console.error('Error updating components:', error);
      alert(error.message || 'Failed to update components');
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '100%',
    marginTop: '10px',
    boxSizing: 'border-box',
    resize: 'vertical'
  };

  const modalBodyStyle = {
    height: '400px',
    overflowY: 'auto',
    overflowX: 'hidden',
  };

  const alertStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 9999,
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '15px',
    borderRadius: '4px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    display: showSuccessAlert ? 'block' : 'none'
  };

  return (
    <div className="App">

      {/* Mobile-only responsive styles */}
      <style>
        {`
          @media (max-width: 767px) {

            /* Edit pencil button - remove background on mobile */
            .edit-components-btn {
              background-color: transparent !important;
              border-color: transparent !important;
              box-shadow: none !important;
              padding: 4px 6px !important;
            }

            .edit-components-btn svg {
              color: #004aad !important;
              fill: #004aad !important;
            }

            .edit-components-btn:hover,
            .edit-components-btn:focus,
            .edit-components-btn:active {
              background-color: transparent !important;
              border-color: transparent !important;
              box-shadow: none !important;
            }

            .components-responsive-modal {
              width: 100%;
              max-width: none;
              margin: 0;
              padding-left: 8px;
              padding-right: 8px;
            }

            .components-responsive-modal .modal-content {
              width: 100%;
              max-width: 100%;
              margin: 0 auto;
              overflow: hidden;
              border-radius: 8px;
            }

            .components-responsive-modal .modal-header {
              padding: 10px 12px;
            }

            .components-responsive-modal .modal-title {
              font-size: 16px !important;
              line-height: 1.2;
              max-width: calc(100% - 35px);
              white-space: normal;
              word-break: break-word;
            }

            .components-responsive-modal .modal-body {
              height: auto !important;
              max-height: calc(100vh - 145px);
              overflow-y: auto !important;
              overflow-x: hidden !important;
              padding: 12px !important;
            }

            .components-responsive-modal .dropdown {
              width: 100%;
              max-width: 100%;
            }

            .components-responsive-modal .dropdown-toggle {
              width: 100%;
              max-width: 100%;
              font-size: 13px;
              padding: 7px 10px;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .components-responsive-modal .dropdown-menu {
              width: 100%;
              max-width: 100%;
              min-width: 0 !important;
              overflow-x: hidden;
            }

            .components-responsive-modal .dropdown-item {
              font-size: 12px;
              padding: 8px 10px;
              white-space: normal;
              word-break: break-word;
            }

            .components-responsive-modal .components-label {
              font-size: 13px;
            }

            .components-responsive-modal .components-textarea {
              font-size: 13px;
              padding: 7px !important;
              min-height: 140px;
              width: 100% !important;
              box-sizing: border-box;
            }

            .components-responsive-modal .modal-footer {
              padding: 8px 12px;
              gap: 6px;
              flex-wrap: wrap;
            }

            .components-responsive-modal .modal-footer .btn {
              font-size: 12px;
              padding: 6px 12px;
            }

            .components-success-alert {
              top: 10px !important;
              right: 10px !important;
              left: 10px !important;
              width: auto !important;
              font-size: 13px !important;
              padding: 10px !important;
            }
          }

          @media (max-width: 380px) {

            .edit-components-btn {
              padding: 2px 4px !important;
            }

            .components-responsive-modal {
              padding-left: 5px;
              padding-right: 5px;
            }

            .components-responsive-modal .modal-header {
              padding: 8px 10px;
            }

            .components-responsive-modal .modal-title {
              font-size: 14px !important;
            }

            .components-responsive-modal .modal-body {
              padding: 10px !important;
            }

            .components-responsive-modal .dropdown-toggle {
              font-size: 12px;
            }

            .components-responsive-modal .dropdown-item {
              font-size: 11px;
            }

            .components-responsive-modal .components-label {
              font-size: 12px;
            }

            .components-responsive-modal .components-textarea {
              font-size: 12px;
            }

            .components-responsive-modal .modal-footer .btn {
              font-size: 11px;
              padding: 5px 10px;
            }
          }
        `}
      </style>

      <Button
        className="edit-components-btn"
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad'
        }}
        onClick={handleShow}
      >
        <FaPencilAlt style={{ fontSize: '20px' }} />
      </Button>

      {showSuccessAlert && (
        <div
          className="components-success-alert"
          style={alertStyle}
        >
          Components updated successfully!
        </div>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        dialogClassName="components-responsive-modal"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: '#004aad',
            borderBottom: '2px solid #ccc'
          }}
        >
          <Modal.Title
            style={{
              color: 'white',
              textAlign: "left",
              display: 'inline-block'
            }}
          >
            Edit Components
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={modalBodyStyle}>

          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              id="dropdown-basic"
            >
              {selectedProcedure}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() =>
                  handleSelect("GUM WORK COMPOSITE")
                }
              >
                GUM WORK COMPOSITE
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <div style={{ marginTop: '20px' }}>
            <label
              htmlFor="components"
              className="components-label"
            >
              Components:
            </label>

            <textarea
              id="components"
              value={componentValue}
              onChange={(e) =>
                setComponentValue(e.target.value)
              }
              className="components-textarea"
              style={inputStyle}
              rows={8}
              placeholder="Enter components details"
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad'
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad'
            }}
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

ComTable.propTypes = {
  caseId: PropTypes.string.isRequired,
  currentComponents: PropTypes.string,
  onUpdate: PropTypes.func
};

ComTable.defaultProps = {
  currentComponents: '',
  onUpdate: () => {}
};

export default ComTable;